import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Divider, Tabs, Typography, styled, } from '@mui/material';
import { useTokens, } from '@mcn-platform/models';
import { StyledTab, TabPanel } from '../common/CustomTab';
import Transcript from '../class/lessonPanel/Transcript';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 2.5,
    marginTop: 0.4,
    marginBottom: 1,
}));
function a11yProps(index) {
    return {
        id: `meeting-tab-${index}`,
        'aria-controls': `meeting-tabpanel-${index}`,
        className: 'meetingDeliveryTabs',
    };
}
const TabsComponent = ({ meeting, settings: { showTranscript = true, } = {}, }) => {
    const [tabIndex, setTabIndex] = React.useState(0);
    const tokens = useTokens();
    const transcript = meeting.recording?.transcript;
    const meetingName = meeting.name.toUpperCase();
    const handleChange = (_event, newValue) => {
        setTabIndex(newValue);
    };
    return (_jsxs(Box, { sx: { width: '100%' }, children: [_jsx(Box, { children: _jsxs(Tabs, { value: tabIndex, onChange: handleChange, "aria-label": "Meeting Tabs", variant: "fullWidth", TabIndicatorProps: { style: { display: 'none' } }, children: [_jsx(StyledTab, { value: 0, sx: { mr: 0.625 }, label: tokens.getToken('courseOverviewLabel'), ...a11yProps(0) }), showTranscript && transcript && (_jsx(StyledTab, { value: 1, label: tokens.getToken('transcriptLabel'), ...a11yProps(1) }))] }) }), _jsxs(TabPanel, { isSelected: tabIndex === 0, index: 0, firstTab: true, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: "bold", children: meetingName }), _jsx(StyledDivider, {}), _jsx(Box, { sx: { pt: 1 }, children: _jsx(Typography, { variant: "body1", sx: { whiteSpace: 'pre-line' }, children: meeting.description }) })] }), showTranscript && transcript && (_jsx(TabPanel, { isSelected: tabIndex === 1, index: 1, lastTab: true, children: _jsx(Transcript, { transcript: transcript, courseName: meetingName }) }))] }));
};
TabsComponent.defaultProps = {
    settings: {
        defaultInfo: 0,
        showOverview: true,
        showTranscript: true,
    },
};
export default observer(TabsComponent);
//# sourceMappingURL=TabsComponent.js.map